import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LegFiJwtService } from '../../../../services/auth/legfi-jwt.service';
import { FeatureDialogComponent } from '../../onboarding/feature-dialog/feature-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogSizes } from '../../../../enums/mat-dialog-sizes.enum';
import { PageAdvertisement } from '../../../../models/entities/page-advertisement';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BankAccountsService } from '../../../../services/financial-accounts/bank-accounts.service';
import { PageAdvertisementTypes } from '../../../../enums/page-advertisement-types.enum';

@UntilDestroy()
@Component({
    selector: 'app-page-advertisement',
    templateUrl: './page-advertisement.component.html',
    styleUrls: ['./page-advertisement.component.scss'],
})
export class PageAdvertisementComponent implements OnInit
{
    @Input() organizationId: number = null;

    private pageAdvertisementSubject: BehaviorSubject<PageAdvertisement> = new BehaviorSubject<PageAdvertisement>(null);
    private ads: PageAdvertisement[] = [
        {
            id: PageAdvertisementTypes.BANKING_INTEGRATION,
            color: '#4C64BD',
            imgSrc: '/assets/images/v2/advertisements/direct-bank-integration.svg',
            tagline: 'Get 100% accurate accounting data with our direct bank integration',
            cta: {
                url: 'https://calendly.com/jbgollpayhoa/15-minute-aab?month=2024-03',
                text: 'Learn More',
            },
        },
        {
            id: PageAdvertisementTypes.PAYABLES,
            color: '#A3407B',
            imgSrc: '/assets/images/v2/advertisements/payables-integration.svg',
            tagline: 'Put your payables on autopilot with our Payabli integration',
            cta: {
                url: '/app/payables/get-started',
                text: 'Learn More',
            },
        }
    ];

    constructor(
            private _dialog: MatDialog,
            private _bankAccountsService: BankAccountsService,
    ) {
    }

    get advertisement$(): Observable<PageAdvertisement> {
        return this.pageAdvertisementSubject.asObservable();
    }

    ngOnInit() {
        const jwt = LegFiJwtService.read();
        if (jwt.admin) {
            if (this.organizationId === null) {
                this.organizationId = jwt.orgId;
            }

            this.checkForAllianceAd();
        }
    }

    openAd(id: number) {
        const data = this.ads.find((ad) => ad.id === id);
        this._dialog.open(FeatureDialogComponent, {
            maxWidth: MatDialogSizes.FULL,
            width: MatDialogSizes.FULL,
            height: MatDialogSizes.FULL,
            data,
        });
        }

    dismissAd(id: number) {
        // TODO: dismiss the ad by id for user
        this.pageAdvertisementSubject.next(null);
    }

    private checkForAllianceAd() {
        const bankAccountStreams = this._bankAccountsService.getOrganizationStreams(this.organizationId);
        let $data = bankAccountStreams.$bankAccounts.asObservable();
        if (!bankAccountStreams.$loading.getValue() && !bankAccountStreams.$loaded.getValue()) {
            $data = this._bankAccountsService.getOrgBankAccounts(this.organizationId);
        }
        $data.pipe(untilDestroyed(this)).subscribe({
            next: () => {
                if (!bankAccountStreams.$isAlliance.getValue()) {
                    this.pageAdvertisementSubject.next(this.ads[0]);
                }
            },
        });
    }
}
